import React from "react";
import { useNavigate } from "react-router-dom";


import heroImg from "../../assets/page-banner-img.jpg";

// ─── Style injection ──────────────────────────────────────────────
const styles = `
  * { box-sizing: border-box; }

  /* ── Hero ── */
  .sap-hero-img {
    width: 100%;
    height: 420px;
    object-fit: cover;
    display: block;
  }

  .sap-hero-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 90px;
    background: rgba(36,199,184,0.72);
    display: flex;
    align-items: center;
    padding-left: 70px;
    padding-right: 70px;
    box-sizing: border-box;
  }

  .sap-hero-title {
    color: #fff;
    font-size: 28px;
    font-weight: 700;
    font-family: "Exo", sans-serif;
    margin: 0;
    line-height: 1.3;
  }

  /* ── Content box ── */
  .sap-content-box {
    width: 90%;
    max-width: 1700px;
    margin: 35px auto;
    background: #fff;
    padding: 40px;
    box-sizing: border-box;
  }

  /* ── Typography ── */
  .sap-page-title {
    text-align: center;
    font-size: 32px;
    font-weight: 800;
    font-family: "Exo", sans-serif;
    color: #111;
    line-height: 1.4;
    margin: 0 0 35px;
  }

  .sap-page-title-mt {
    margin-top: 65px;
  }

  .sap-page-title-mt2 {
    margin-top: 70px;
  }

  .sap-page-title-mt3 {
    margin-top: 75px;
  }

  .sap-section-title {
    font-size: 30px;
    font-weight: 800;
    font-family: "Exo", sans-serif;
    color: #111;
    line-height: 1.45;
    margin: 55px 0 22px;
  }

  .sap-sub-title {
    font-size: 22px;
    font-weight: 700;
    font-family: "Exo", sans-serif;
    color: #111;
    line-height: 1.45;
    margin: 35px 0 18px;
  }

  .sap-p {
    font-size: 15px;
    line-height: 1.8;
    color: #111;
    margin-bottom: 18px;
  }

  .sap-li {
    font-size: 15px;
    line-height: 1.9;
    color: #111;
    margin-bottom: 10px;
  }

  .sap-link {
    font-size: 15px;
    line-height: 1.7;
    margin-bottom: 10px;
    word-break: break-all;
    color: #111;
  }

  /* ── Table ── */
  .sap-table-wrap {
    overflow-x: auto;
    margin-bottom: 45px;
    -webkit-overflow-scrolling: touch;
  }

  .sap-table {
    width: 100%;
    border-collapse: collapse;
    background: #f3f3f3;
    min-width: 700px;
  }

  .sap-table th {
    border: 1px solid #ccc;
    padding: 14px;
    font-size: 14px;
    background: #173b8f;
    color: #fff;
    text-align: left;
    line-height: 1.5;
  }

  .sap-table td {
    border: 1px solid #ccc;
    padding: 12px 14px;
    font-size: 14px;
    line-height: 1.6;
    vertical-align: top;
  }

  /* ── Code blocks ── */
  .sap-code-block {
    background: #f3f3f3;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 24px;
    margin-bottom: 28px;
    font-family: monospace;
    font-size: 13px;
    line-height: 2;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .sap-code-block pre {
    margin: 0;
    white-space: pre-wrap;
    color: #111;
    word-break: break-word;
  }

  /* ── References box ── */
  .sap-refs-box {
    background: #f3f3f3;
    padding: 24px;
    margin-bottom: 55px;
  }

  /* ── Nav footer ── */
  .sap-nav-footer {
    border: 2px solid #fff;
    padding: 28px;
    background: #24c7b8;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 28px;
    align-items: start;
  }

  .sap-nav-prev {
    cursor: pointer;
    border-right: 1px solid rgba(255,255,255,0.55);
    padding-right: 25px;
  }

  .sap-nav-next {
    cursor: pointer;
    text-align: right;
  }

  .sap-nav-post-title {
    font-size: 20px;
    line-height: 1.5;
    color: #10213a;
    font-weight: 700;
    margin-bottom: 16px;
    font-family: "Exo", sans-serif;
  }

  .sap-nav-label {
    color: #d4d4d4;
    font-size: 17px;
    margin: 0;
    font-weight: 500;
  }

  /* ── Ultra-wide: 1920px+ ── */
  @media (min-width: 1920px) {
    .sap-hero-img { height: 520px; }
    .sap-hero-overlay { height: 110px; padding-left: 100px; padding-right: 100px; }
    .sap-hero-title { font-size: 34px; }
    .sap-content-box { padding: 56px; }
    .sap-page-title { font-size: 38px; }
    .sap-section-title { font-size: 34px; }
    .sap-sub-title { font-size: 26px; }
    .sap-p, .sap-li, .sap-link { font-size: 16px; }
    .sap-table th, .sap-table td { font-size: 15px; padding: 16px; }
  }

  /* ── Large Desktop: 1400px – 1919px ── */
  @media (max-width: 1919px) and (min-width: 1400px) {
    .sap-hero-img { height: 460px; }
    .sap-hero-title { font-size: 30px; }
    .sap-content-box { padding: 48px; }
  }

  /* ── Small Desktop / Laptop: 1024px – 1399px ── */
  @media (max-width: 1399px) and (min-width: 1024px) {
    .sap-hero-img { height: 380px; }
    .sap-hero-title { font-size: 26px; }
    .sap-hero-overlay { height: 82px; padding-left: 50px; padding-right: 50px; }
    .sap-content-box { padding: 36px; }
    .sap-page-title { font-size: 28px; }
    .sap-section-title { font-size: 26px; }
    .sap-sub-title { font-size: 20px; }
  }

  /* ── Tablet Portrait: 768px – 1023px ── */
  @media (max-width: 1023px) and (min-width: 768px) {
    .sap-hero-img { height: 300px; }
    .sap-hero-overlay { height: 76px; padding-left: 36px; padding-right: 36px; }
    .sap-hero-title { font-size: 20px; }
    .sap-content-box { width: 94%; padding: 28px 24px; margin: 26px auto; }
    .sap-page-title { font-size: 24px; margin-bottom: 26px; }
    .sap-page-title-mt { margin-top: 50px; }
    .sap-page-title-mt2 { margin-top: 55px; }
    .sap-page-title-mt3 { margin-top: 55px; }
    .sap-section-title { font-size: 22px; margin: 42px 0 18px; }
    .sap-sub-title { font-size: 18px; margin: 28px 0 14px; }
    .sap-p, .sap-li, .sap-link { font-size: 14px; }
    .sap-table th, .sap-table td { font-size: 13px; padding: 10px 12px; }
    .sap-code-block { font-size: 12px; padding: 18px; }
    .sap-nav-footer { gap: 20px; padding: 22px; }
    .sap-nav-post-title { font-size: 17px; }
    .sap-nav-label { font-size: 15px; }
  }

  /* ── Large Mobile: 481px – 767px ── */
  @media (max-width: 767px) and (min-width: 481px) {
    .sap-hero-img { height: 220px; }
    .sap-hero-overlay { height: 68px; padding-left: 22px; padding-right: 22px; }
    .sap-hero-title { font-size: 16px; }
    .sap-content-box { width: 97%; padding: 22px 16px; margin: 20px auto; }
    .sap-page-title { font-size: 21px; margin-bottom: 20px; }
    .sap-page-title-mt { margin-top: 42px; }
    .sap-page-title-mt2 { margin-top: 48px; }
    .sap-page-title-mt3 { margin-top: 50px; }
    .sap-section-title { font-size: 19px; margin: 36px 0 16px; }
    .sap-sub-title { font-size: 16px; margin: 24px 0 12px; }
    .sap-p, .sap-li, .sap-link { font-size: 14px; }
    .sap-table th, .sap-table td { font-size: 12px; padding: 9px 10px; }
    .sap-code-block { font-size: 11.5px; padding: 16px; line-height: 1.8; }
    .sap-refs-box { padding: 18px; }
    .sap-nav-footer {
      grid-template-columns: 1fr;
      gap: 0;
      padding: 18px;
    }
    .sap-nav-prev {
      border-right: none;
      border-bottom: 1px solid rgba(255,255,255,0.55);
      padding-right: 0;
      padding-bottom: 18px;
      margin-bottom: 18px;
    }
    .sap-nav-next { text-align: left; }
    .sap-nav-post-title { font-size: 16px; }
    .sap-nav-label { font-size: 14px; }
  }

  /* ── Small Mobile: up to 480px ── */
  @media (max-width: 480px) {
    .sap-hero-img { height: 180px; }
    .sap-hero-overlay { height: 60px; padding-left: 14px; padding-right: 14px; }
    .sap-hero-title { font-size: 13px; }
    .sap-content-box { width: 100%; padding: 16px 12px; margin: 14px auto; }
    .sap-page-title { font-size: 18px; margin-bottom: 16px; }
    .sap-page-title-mt { margin-top: 36px; }
    .sap-page-title-mt2 { margin-top: 40px; }
    .sap-page-title-mt3 { margin-top: 42px; }
    .sap-section-title { font-size: 17px; margin: 30px 0 14px; }
    .sap-sub-title { font-size: 15px; margin: 20px 0 10px; }
    .sap-p, .sap-li, .sap-link { font-size: 13.5px; }
    .sap-table th, .sap-table td { font-size: 11.5px; padding: 8px 9px; }
    .sap-code-block { font-size: 11px; padding: 12px; line-height: 1.75; }
    .sap-refs-box { padding: 14px; }
    .sap-nav-footer {
      grid-template-columns: 1fr;
      gap: 0;
      padding: 14px;
    }
    .sap-nav-prev {
      border-right: none;
      border-bottom: 1px solid rgba(255,255,255,0.55);
      padding-right: 0;
      padding-bottom: 14px;
      margin-bottom: 14px;
    }
    .sap-nav-next { text-align: left; }
    .sap-nav-post-title { font-size: 14px; margin-bottom: 10px; }
    .sap-nav-label { font-size: 13px; }
  }

  /* ── Extra Small: up to 400px ── */
  @media (max-width: 400px) {
    .sap-hero-img { height: 155px; }
    .sap-hero-overlay { height: 56px; padding-left: 10px; padding-right: 10px; }
    .sap-hero-title { font-size: 12px; }
    .sap-content-box { padding: 14px 10px; }
    .sap-page-title { font-size: 16px; }
    .sap-section-title { font-size: 15px; }
    .sap-sub-title { font-size: 14px; }
    .sap-p, .sap-li, .sap-link { font-size: 13px; }
    .sap-table th, .sap-table td { font-size: 11px; padding: 7px 8px; }
    .sap-code-block { font-size: 10.5px; padding: 10px; }
  }

  /* ── Very Small: up to 360px ── */
  @media (max-width: 360px) {
    .sap-hero-img { height: 130px; }
    .sap-hero-overlay { height: 50px; }
    .sap-hero-title { font-size: 11px; }
    .sap-content-box { padding: 12px 8px; }
    .sap-page-title { font-size: 15px; }
    .sap-section-title { font-size: 14px; }
    .sap-sub-title { font-size: 13px; }
  }
`;

// ─── Style token objects (used inline where needed) ───────────────
const ul = { paddingLeft: "30px", marginBottom: "28px" };
const ulNested = { paddingLeft: "22px", marginTop: "8px" };
const ulSm = { paddingLeft: "30px", marginBottom: "18px" };
const ol = { paddingLeft: "30px", marginBottom: "28px" };

// ─── Component ───────────────────────────────────────────────────
const SAPAutomationPage = () => {
  const navigate = useNavigate();

  const tableHeaders = [
    "Technology / Vendor",
    "Type",
    "Accuracy level (with source)",
    "Open-source / Commercial",
    "Notable case studies / implementations",
    "SAP integration notes",
  ];

  const tableRows = [
    [
      "SAP Document Information Extraction (SAP BTP)",
      "Document AI / IDP",
      "No public P/R/F1 docs; positioned as ML-based extraction for business docs (invoice PDFs/images).",
      "Commercial (SAP BTP service)",
      "SAP tutorials for extracting structured info from invoices.",
      "Native SAP ecosystem pair with SAP Integration Suite / S4/HANA.",
    ],
    [
      "Microsoft Azure Document Intelligence",
      "Document AI / IDP",
      "Confidence score model; Microsoft targets ≥80% accuracy (higher for structured financial docs).",
      "Commercial",
      "—",
      "On-prem via containers; SAP integration via APIs/middleware.",
    ],
    [
      "Google Document AI – Invoice Parser",
      "Document AI / IDP",
      "Extracts up to 46 entities; supports custom fields.",
      "Commercial",
      "FibroGen case study (HITL reduced cycle time).",
      "SAP integration via Google Cloud APIs.",
    ],
    [
      "Donut (OCR-free Document Understanding Transformer)",
      "Research model (VLM)",
      "Avoids OCR error propagation; strong performance in document understanding benchmarks.",
      "Open-source",
      "Model repo + research paper.",
      "Not SAP-specific; requires engineering layer.",
    ],
    [
      "Veryfi Invoice OCR API",
      "Invoice-parsing API",
      "Provides invoice extraction incl. line items.",
      "Commercial",
      "—",
      "Custom SAP integration (REST → SAP mapping).",
    ],
    [
      "Nanonets Invoice OCR",
      "Invoice parsing API / IDP",
      "Lists line items; SAP integrations (plan dependent).",
      "Commercial",
      "—",
      "Export/API integration with SAP.",
    ],
    [
      "Klippa Invoice OCR",
      "Invoice parsing API",
      "Claims up to 99% accuracy.",
      "Commercial",
      "Customer automation stories.",
      "Published Klippa→SAP invoice processing flow.",
    ],
    [
      "DocILE Benchmark (Rossum et al.)",
      "Benchmark dataset",
      "Defines invoice extraction metrics (LIR).",
      "Open-source",
      "DocILE dataset + paper.",
      "Not SAP connector.",
    ],
    [
      "OpenText Vendor Invoice Management (VIM) for SAP",
      "SAP-focused AP automation / IDP",
      "Integrated invoice workflow management.",
      "Commercial",
      "SAP product positioning (SAP VIM).",
      "Deep SAP integration; replaces/extends MIRO.",
    ],
    [
      "Tungsten Automation (Kofax / ReadSoft)",
      "IDP / Capture for SAP",
      "Direct SAP connector configuration.",
      "Commercial",
      "—",
      "Strong SAP heritage integrations.",
    ],
    [
      "UiPath Document Understanding",
      "IDP within RPA platform",
      "Example: 824k invoices/year, 85% accuracy, 53% STP.",
      "Commercial",
      "Thermo Fisher case study.",
      "SAP posting via UiPath SAP activities.",
    ],
    [
      "Mindee Invoice OCR API",
      "Invoice parsing API",
      "Trained on real invoices; exposes confidence scores.",
      "Commercial",
      "—",
      "ERP/SAP integration via middleware.",
    ],
    [
      "AWS Textract",
      "OCR + Document AI",
      "Extracts SummaryFields & LineItemGroups; async support.",
      "Commercial",
      "AWS reference architectures.",
      "SAP integration via middleware/RPA.",
    ],
    [
      "ABBYY Vantage / FlexiCapture",
      "Enterprise IDP",
      "Customer story: 80% no-touch processing.",
      "Commercial",
      "Invoice automation case studies.",
      "FlexiCapture SAP connector available.",
    ],
    [
      "Rossum",
      "Cloud IDP",
      "~95% extraction accuracy; ~80% automation first month.",
      "Commercial",
      "Trust customer story.",
      "Certified SAP integrations.",
    ],
  ];

  const references = [
    "https://help.sap.com/docs/SAP_S4HANA_ON-PREMISE/25a41481f62e469ba0e61015a0d39d20/e9a062543da42357e10000000a44176d.html",
    "https://learn.microsoft.com/en-us/azure/ai-services/document-intelligence/concept/accuracy-confidence?view=doc-intel-4.0.0",
    "https://arxiv.org/abs/2111.15664",
    "https://developers.sap.com/tutorials/cp-aibus-dox-ui..html",
    "https://learn.microsoft.com/en-us/azure/ai-services/document-intelligence/containers/install-run?view=doc-intel-4.0.0",
    "https://docs.cloud.google.com/document-ai/docs/pretrained-overview",
    "https://www.abbyy.com/solutions/technology/sap/",
    "https://rossum.ai/integrations/sap/",
    "https://storage.googleapis.com/cloud-samples-data/documentai/labeling-instructions/pretrained-invoice-v1.4-2022-10-21.pdf",
    "https://help.sap.com/docs/SAP_S4HANA_CLOUD/bb9f1469daf04bd894ab2167f8132a1a/7bc52558ef790a02e10000000a44147b.html",
    "https://research.aimultiple.com/ocr-accuracy/",
    "https://arxiv.org/abs/2302.05658",
    "https://cloud.google.com/blog/products/ai-machine-learning/reducing-invoice-processing-with-document-ai",
    "https://docs.aws.amazon.com/textract/latest/dg/API_AnalyzeExpense.html",
    "https://aws.amazon.com/blogs/machine-learning/build-a-receipt-and-invoice-processing-pipeline-with-amazon-textract/",
    "https://www.abbyy.com/customer-stories/costain-transforms-its-finance-department-using-abbyy-intelligent-document-processing/",
    "https://rossum.ai/customer-stories/trust/",
    "https://www.opentext.com/products/vendor-invoice-management-for-sap-solutions",
    "https://www.sap.com/products/financial-management/invoice-management.html",
    "https://docshield.tungstenautomation.com/APAgility/en_US/2.3.0-2jf4h43rcd/help/CFG/APAgility_Configuration_Help/UseConfiguration/ManageExtractionandValidation/ProjectandFieldConfigurations/t_ConfigureaConnectiontoSAP.html",
    "https://www.uipath.com/solutions/department/finance-and-accounting-automation/invoice-automation",
    "https://www.uipath.com/resources/automation-case-studies/document-understanding-reduces-thermo-fisher-scientific-invoice-process",
    "https://www.mindee.com/product/invoice-ocr-api",
    "https://www.veryfi.com/invoice-ocr-api/",
    "https://docs.veryfi.com/",
    "https://nanonets.com/ocr-api/invoice-ocr",
    "https://nanonets.com/pricing",
    "https://www.klippa.com/en/ocr/financial-documents/invoices/",
    "https://www.klippa.com/en/spendcontrol-en/integrations/sap/invoice-processing/",
    "https://docile.rossum.ai/",
    "https://github.com/clovaai/donut",
    "https://docs.cloud.google.com/document-ai/docs/uptrain-pretrained-processor",
    "https://docs.cloud.google.com/document-ai/limits",
    "https://docs.cloud.google.com/document-ai/docs/regions",
    "https://docs.cloud.google.com/document-ai/docs/processors-list",
    "https://cloud.google.com/document-ai/pricing",
    "https://learn.microsoft.com/en-us/azure/ai-services/document-intelligence/prebuilt/invoice?view=doc-intel-4.0.0",
    "https://learn.microsoft.com/en-us/azure/ai-services/document-intelligence/service-limits?view=doc-intel-4.0.0",
    "https://learn.microsoft.com/en-us/azure/ai-services/document-intelligence/containers/disconnected?view=doc-intel-4.0.0",
    "https://docs.aws.amazon.com/textract/latest/dg/limits-document.html",
    "https://docs.aws.amazon.com/textract/latest/dg/limits-quotas-explained.html",
    "https://aws.amazon.com/textract/pricing/",
    "https://www.abbyy.com/marketplace/assets/host/abbyy/process-skill/invoice-processing/",
    "https://www.abbyy.com/customer-stories/pepsico-automates-invoice-processing-with-abbyy-flexicapture/",
    "https://rossum.app/api/docs/",
    "https://docs.veryfi.com/api/receipts-invoices/get-document-line-items/",
    "https://help.sap.com/docs/document-information-extraction/document-information-extraction/data-protection-and-privacy",
  ];

  return (
    <>
      <style>{styles}</style>

      <div style={{ background: "#24c7b8", minHeight: "100vh", paddingBottom: "50px" }}>

        {/* HERO */}
        <div style={{ width: "100%", position: "relative", overflow: "hidden" }}>
          <img src={heroImg} alt="SAP Automation" className="sap-hero-img" />
          <div className="sap-hero-overlay">
            <h1 className="sap-hero-title">
              Automating Purchase & Sales Invoice Entry into SAP: A Research
              Guide to Document AI, APIs, and LLMs
            </h1>
          </div>
        </div>

        {/* CONTENT BOX */}
        <div className="sap-content-box">

          {/* ── EXECUTIVE SUMMARY ── */}
          <h1 className="sap-page-title">Executive summary</h1>

          <p className="sap-p">
            Automating the entry of supplier (purchase) invoices and customer
            (sales) bills into SAP is best treated as an{" "}
            <strong>end-to-end document-to-posting pipeline</strong>, not just
            "OCR". In practice, the hardest problems are (a){" "}
            <strong>multi-page, multi-line-item extraction</strong> (tables that
            split across pages, inconsistent column layouts), (b){" "}
            <strong>normalisation and reconciliation</strong> (tax, totals, PO
            matching, vendor master matching), and (c){" "}
            <strong>posting safely into SAP</strong> with strong controls
            (parking/approval, audit trail, error handling). SAP posting can be
            done via <strong>IDocs (e.g., INVOIC02)</strong>, classic{" "}
            <strong>BAPIs</strong>, or <strong>S/4HANA OData APIs</strong> such
            as <strong>Supplier Invoice – OData</strong>{" "}
            (API_SUPPLIERINVOICE_PROCESS_SRV_0001).
          </p>

          <p className="sap-p">Across technologies, the most reliable enterprise patterns are:</p>

          <ul style={ul}>
            <li className="sap-li">
              <strong>Document AI / Intelligent Document Processing (IDP) platforms with invoice models</strong>{" "}
              (SAP Document Information Extraction, Azure Document Intelligence,
              Google Document AI Invoice Parser, AWS Textract AnalyzeExpense,
              ABBYY, Rossum, OpenText VIM, Tungsten) combined with{" "}
              <strong>human-in-the-loop (HITL)</strong> and{" "}
              <strong>business-rule validation</strong>. Many platforms expose{" "}
              <strong>confidence scores</strong> explicitly for gating HITL.
            </li>
            <li className="sap-li">
              <strong>LLM-based extraction</strong> is strongest when used as a{" "}
              <strong>post-processor</strong> (schema mapping, exception
              reasoning, fuzzy matching, enrichment) or as a{" "}
              <strong>hybrid</strong> with layout-aware extraction; end-to-end
              "LLM reads the PDF and outputs JSON" can work, but requires careful
              control against hallucinations and needs rigorous evaluation for
              finance-grade accuracy. Research shows strong results for document
              understanding models (e.g., Donut) and invoice-specific benchmarks
              (DocILE includes line-item recognition).
            </li>
          </ul>

          <h2 className="sap-section-title">
            Shortlist recommendation (typical best fit for high-accuracy SAP ingestion):
          </h2>

          <ol style={ol}>
            <li className="sap-li">
              <strong>SAP Document Information Extraction (BTP) + SAP Integration Suite/Build Process Automation</strong>{" "}
              for SAP-centric estates, especially if you want a supportable SAP-native architecture.
            </li>
            <li className="sap-li">
              <strong>Microsoft Azure Document Intelligence (Invoice model) + SAP integration (OData/IDoc/BAPI) via middleware</strong>{" "}
              when you need strong enterprise controls and optional on-prem/container deployment.
            </li>
            <li className="sap-li">
              <strong>Google Document AI Invoice Parser + SAP Cloud Integration (or equivalent middleware)</strong>{" "}
              when you want mature invoice parsing with uptraining and regional processing controls; a published SAP
              integration case study (FibroGen) shows a clear pattern including thresholded HITL.
            </li>
            <li className="sap-li">
              <strong>ABBYY (Vantage / FlexiCapture) + SAP Intelligent RPA / SAP connectors</strong>{" "}
              for enterprises that prioritise classic IDP controls, on-prem options, and deep capture workflows.
            </li>
            <li className="sap-li">
              <strong>Rossum + SAP certified integration</strong> where you want a SaaS-first IDP product with
              documented SAP partner positioning and strong "time-to-value" for invoice queues.
            </li>
          </ol>

          <p className="sap-p">
            A rigorous pilot should measure <strong>field-level exact match</strong> and{" "}
            <strong>table/line-item quality</strong> separately, include{" "}
            <strong>stratified invoice sets</strong> (suppliers, layouts, languages), and track business
            outcomes like <strong>straight-through processing (STP) rate</strong> and{" "}
            <strong>posting success</strong>. Google's own invoice labelling guidance suggests dataset
            sizing on the order of <strong>≥1,000 training invoices per language</strong> and{" "}
            <strong>≥200 test invoices per language</strong> when uptraining.
          </p>

          {/* ── SAP CONTEXT ── */}
          <h1 className={`sap-page-title sap-page-title-mt`}>
            SAP context and integration requirements
          </h1>

          <h2 className="sap-sub-title">What "invoice entry into SAP" usually means:</h2>

          <p className="sap-p">
            Because your estate is "SAP ECC or S/4HANA (unspecified)", your integration choices and effort
            depend on which posting interface is preferred/available:
          </p>

          <ul style={ul}>
            <li className="sap-li">
              <strong>IDoc-based integration</strong> is common for ECC and S/4HANA landscapes and is widely
              used for invoice/billing structured exchange. SAP provides technical information for{" "}
              <strong>INVOIC02</strong> (invoice IDoc) including enhanced segments.
            </li>
            <li className="sap-li">
              <strong>S/4HANA APIs (OData)</strong> are increasingly the default for modern integrations.
              SAP's "Supplier Invoice – OData V2" service (API_SUPPLIERINVOICE_PROCESS_SRV_0001) explicitly
              supports creating supplier invoices (and parked/held variants).
            </li>
          </ul>

          <p className="sap-p">In practice, invoice ingestion pipelines often:</p>

          <ol style={ol}>
            <li className="sap-li">Extract invoice header + line items + totals.</li>
            <li className="sap-li">Validate arithmetic (subtotal + tax + shipping = total), currency/format, duplicate checks.</li>
            <li className="sap-li">Enrich/resolve SAP master data (vendor, company code, tax codes, GL account, cost centre, PO reference).</li>
            <li className="sap-li"><strong>Park</strong> or <strong>post</strong> in SAP, with an approval workflow for exceptions.</li>
          </ol>

          <h2 className="sap-sub-title">Why multi-page and line items dominate complexity:</h2>

          <p className="sap-p">
            Line items are typically represented as tables; tables can: spread across pages, change layout
            across suppliers, contain nested or wrapped descriptions, omit headers on continuation pages,
            and mix units and prices in inconsistent formats. This is why most invoice automation solutions
            treat line items as a special "multi-occurrence" structure (not just key-value fields). Google's
            invoice labelling guidance explicitly separates single-occurrence entities from{" "}
            <strong>OPTIONAL_MULTIPLE</strong> entities, calling out <strong>line item</strong> and{" "}
            <strong>VAT</strong> as multi-occurrence.
          </p>

          {/* ── COMPARATIVE ANALYSIS ── */}
          <h1 className={`sap-page-title sap-page-title-mt2`}>
            Comparative analysis of approach families: OCR, Document AI/IDP, invoice APIs, and LLM extraction
          </h1>

          <h2 className="sap-sub-title">OCR engines as a foundation layer:</h2>

          <ul style={ul}>
            <li className="sap-li">
              <strong>What OCR is good at:</strong> converting pixels to text (printed text particularly);
              it is necessary but not sufficient for invoice posting because SAP needs structured fields and
              line-item tables, not raw text.
            </li>
            <li className="sap-li">
              <strong>Typical metrics:</strong> character/word accuracy (CER/WER), sometimes "text accuracy".
              Independent OCR benchmarks report high text accuracy for leading engines on clean data (e.g.,
              Google Vision and AWS Textract are often reported near the top in published comparisons), but
              this does not directly translate into correct invoice fields or correct line items.
            </li>
            <li className="sap-li">
              <strong>When OCR-only makes sense:</strong> only when input invoices are highly standardised
              (few suppliers/templates) and you can use deterministic rules/templates—otherwise maintenance
              cost grows quickly.
            </li>
          </ul>

          <h2 className="sap-sub-title">Document AI / IDP with invoice models:</h2>

          <p className="sap-p">
            This category includes hyperscaler services and enterprise IDP platforms. Core traits: pretrained
            invoice schemas (header fields, totals, supplier/buyer blocks); special handling of{" "}
            <strong>line items</strong> (table extraction or line-item grouping); confidence scores to route
            low-confidence fields to review. Microsoft defines confidence explicitly as an estimated
            probability (0–1) and recommends confidence-based human review for critical workflows.
          </p>

          <ul style={ul}>
            <li className="sap-li">
              <strong>Strengths:</strong> best balance of accuracy, scalability, and operationalisation for
              multi-format invoices (PDFs, scans, photos).
            </li>
            <li className="sap-li">
              <strong>Limitations:</strong> accuracy varies by supplier layout, language and scan quality;
              vendors rarely publish rigorous third-party audited numbers, so pilots matter.
            </li>
          </ul>

          <h2 className="sap-sub-title">Invoice-parsing APIs (specialist SaaS):</h2>

          <p className="sap-p">
            These are usually REST APIs focusing on "invoices/receipts/bills" and often include: prebuilt
            invoice models, line item extraction endpoints, workflow/integration tooling (Zapier/Make/n8n,
            webhooks), and sometimes ERP integration claims. They can be cost-effective and fast to integrate,
            but enterprise readiness varies by vendor (SLA, SSO, data residency, private deployment, audit logs).
          </p>

          <h2 className="sap-sub-title">LLM-based extraction and hybrid pipelines:</h2>

          <p className="sap-p">LLM approaches split into two patterns:</p>

          <ul style={ulSm}>
            <li className="sap-li">
              <strong>OCR + LLM (text-only):</strong> OCR produces text + layout hints; LLM maps text to a
              strict schema, performs normalisation, and handles exceptions.
            </li>
            <li className="sap-li">
              <strong>Vision-language / document understanding models:</strong> models like{" "}
              <strong>Donut</strong> propose OCR-free document understanding and report strong
              speed/accuracy characteristics across document understanding tasks, though production invoice
              pipelines still typically combine OCR/layout + validation.
            </li>
          </ul>

          <p className="sap-p">
            For invoice-specific evaluation, <strong>DocILE</strong> is an important benchmark because it
            explicitly covers both <strong>Key Information Localization and Extraction (KILE)</strong> and{" "}
            <strong>Line Item Recognition (LIR)</strong> across business documents (including invoices and
            purchase orders).
          </p>

          <p className="sap-p">
            <strong>Enterprise caveat:</strong> LLMs can produce plausible but wrong outputs; finance
            workflows require deterministic validation (totals, tax rules, PO matching) and robust HITL gating.
          </p>

          {/* ── VENDOR TABLE ── */}
          <h1 className={`sap-page-title sap-page-title-mt2`}>
            Technology and vendor landscape with SAP relevance
          </h1>

          <h2 className="sap-sub-title">
            Summary table: accuracy evidence, case studies, and SAP integration notes:
          </h2>

          <p className="sap-p">
            The table below focuses on <em>evidence you can actually cite</em>. Where vendors do not publish
            field-level precision/recall/F1, the "accuracy" column uses either (a) confidence scoring
            semantics, (b) case-study reported figures, or (c) clearly-labelled marketing claims.
          </p>

          <div className="sap-table-wrap">
            <table className="sap-table">
              <thead>
                <tr>
                  {tableHeaders.map((h, i) => (
                    <th key={i}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableRows.map((row, i) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? "#fff" : "#f9f9f9" }}>
                    {row.map((cell, j) => (
                      <td key={j}>{cell}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ── DETAILED PROFILES ── */}
          <h1 className={`sap-page-title sap-page-title-mt2`}>
            Detailed profiles for key "enterprise-ready" options
          </h1>

          <h2 className="sap-sub-title">Google Document AI Invoice Parser:</h2>
          <p className="sap-p">
            Google's pretrained Invoice Parser is explicitly positioned as a pretrained procurement parser
            that extracts invoice entities and supports <strong>enrichment and normalisation</strong>; the
            pretrained overview states Invoice Parser can extract <strong>up to 46 generic entities</strong>.
            It supports <strong>uptraining a pretrained processor</strong> to improve accuracy on specific
            invoice formats and to extract fields not supported by the pretrained model.
          </p>
          <p className="sap-p">
            <strong>Input formats and scale:</strong> Document AI system limits depend on processor type;
            the limits page shows processor-level maximum pages (online/synchronous typically 15 pages;
            batch/offline up to 200 pages for extraction processors; Invoice Parser has similar constraints),
            with an "imageless_mode" option to extend synchronous limits to 30 pages.
          </p>
          <p className="sap-p">
            <strong>Security/data locality:</strong> Google's docs state you must select a regional or
            multi-regional location for processing/storage, including <strong>EU</strong> and{" "}
            <strong>US</strong> multi-regions. Google also states Document AI processors adhere to Data
            Processing and Security Terms.
          </p>
          <p className="sap-p">
            <strong>SAP integration evidence:</strong> The FibroGen case study provides a concrete
            end-to-end pattern: invoices uploaded to Cloud Storage trigger Cloud Functions that call
            Document AI; output is forwarded to <strong>SAP Cloud Integration</strong> which applies
            validations/business rules and uploads into SAP (noted as "SAP R/4" in the blog), with a
            configurable threshold to route to human approval.
          </p>
          <p className="sap-p">
            <strong>Pricing model:</strong> per-page Document AI pricing is publicly documented (varies by processor).
          </p>
          <p className="sap-p">
            <strong>Enterprise maturity:</strong> strong; widely used; supports uptraining; but still
            requires careful pilot evaluation for your suppliers and languages.
          </p>

          <h2 className="sap-sub-title">Microsoft Azure Document Intelligence (Invoice model):</h2>
          <p className="sap-p">
            Azure's invoice model is explicitly designed to extract <strong>key fields and line items</strong>{" "}
            from invoices and similar documents (utility bills, purchase orders), across scans and PDFs;
            it also states invoice language support (27 languages in the invoice model documentation).
          </p>
          <p className="sap-p">
            <strong>Input formats and multi-page:</strong> Service limits list supported document types and
            quotas. Standard tier supports PDF and image formats (JPEG/PNG/BMP/TIFF/HEIF) and supports up to{" "}
            <strong>2000 pages (analysis)</strong> and <strong>500 MB</strong> max document size (Standard
            tier), with default <strong>15 TPS</strong> for analyse requests.
          </p>
          <p className="sap-p">
            <strong>On-prem / data residency:</strong> Microsoft provides Document Intelligence{" "}
            <strong>Docker containers</strong> for on-premises use, and explicitly notes containers can be
            used on-premises to extract structured data. It also documents support for containers in specific
            model versions, including Invoice model support in certain GA versions (and guidance for
            disconnected environments).
          </p>
          <p className="sap-p">
            <strong>Accuracy instrumentation:</strong> Microsoft explains confidence scores as estimated
            probabilities and provides guidance for interpreting model accuracy/confidence scores. This is
            important because many deployments gate auto-posting vs human verification using confidence.
          </p>
          <p className="sap-p">
            <strong>SAP integration:</strong> typically via middleware (SAP Integration Suite, Azure
            integration services, custom API layer) to post via IDoc/BAPI/OData; the SAP-side interface
            choice should follow the ECC vs S/4 decision.
          </p>

          <h2 className="sap-sub-title">AWS Textract (AnalyzeExpense / StartExpenseAnalysis):</h2>
          <p className="sap-p">
            Textract provides an expense/invoice capability via <strong>AnalyzeExpense</strong>{" "}
            (synchronous) and <strong>StartExpenseAnalysis/GetExpenseAnalysis</strong> (asynchronous).
            AnalyzeExpense returns <strong>ExpenseDocuments</strong> separated into{" "}
            <strong>SummaryFields</strong> (header-like fields) and{" "}
            <strong>LineItemGroups/LineItems</strong> (line details).
          </p>
          <p className="sap-p">
            <strong>Input formats and multi-page constraints:</strong> AWS documents accepted formats
            (JPEG/PNG/PDF/TIFF) and explicitly states page limits: synchronous operations support only 1
            page for PDF/TIFF, whereas asynchronous operations support up to <strong>3,000 pages</strong>{" "}
            for PDF/TIFF (and up to 500 MB for async PDF/TIFF).
          </p>
          <p className="sap-p">
            <strong>Throughput/scaling:</strong> AWS describes quotas in TPS and concurrent jobs for async
            operations, which is relevant for high-volume invoice ingestion patterns (queue + async processing).
          </p>
          <p className="sap-p">
            <strong>Pricing:</strong> Textract pricing is per page, with published examples for AnalyzeExpense.
          </p>
          <p className="sap-p">
            <strong>SAP integration:</strong> typically custom; Textract does not "post to SAP" itself.
            You'll still need rule validation, vendor/PO matching, then SAP posting via IDoc/BAPI/OData.
          </p>

          <h2 className="sap-sub-title">ABBYY Vantage / FlexiCapture:</h2>
          <p className="sap-p">
            ABBYY's invoice processing skills describe enterprise features: human-in-the-loop verification
            based on thresholds, system learning from human interaction, and the ability to train models on
            customer documents "in real time".
          </p>
          <p className="sap-p">
            <strong>SAP integration:</strong> ABBYY explicitly positions its SAP partnership and notes a{" "}
            <strong>FlexiCapture Connector for SAP Intelligent RPA</strong>, downloadable from the SAP
            Intelligent RPA store.
          </p>
          <p className="sap-p">
            <strong>Real-world outcomes:</strong> ABBYY customer stories provide operational metrics such
            as "80% of all invoices processed without any human touch" in one deployment (Costain). Other
            ABBYY stories cite invoice processing in SAP contexts (e.g., PepsiCo manual entry into SAP was
            replaced by automation with ABBYY FlexiCapture).
          </p>
          <p className="sap-p">
            <strong>Deployment:</strong> ABBYY offerings often include on-prem and cloud options (verify
            per product edition and contract).
          </p>

          <h2 className="sap-sub-title">Rossum:</h2>
          <p className="sap-p">
            Rossum provides a clear SAP integration positioning: it states it is an{" "}
            <strong>official SAP partner</strong> and has "certified integrations" connecting with SAP ERP products.
          </p>
          <p className="sap-p">
            <strong>Real-world accuracy evidence:</strong> Rossum's Trust customer story reports ~
            <strong>95% data extraction accuracy</strong> and ~<strong>80% automation</strong> in the first
            month, plus a reported processing lead time of ~<strong>10 seconds</strong>.
          </p>
          <p className="sap-p">
            <strong>APIs/SDKs:</strong> Rossum provides a developer portal and API documentation for
            integration and workflow automation.
          </p>

          <h2 className="sap-sub-title">OpenText Vendor Invoice Management (VIM) for SAP:</h2>
          <p className="sap-p">
            OpenText VIM for SAP is positioned as an SAP-integrated procure-to-pay document processing
            solution with preconfigured enrichments, business rules and workflows. SAP also markets "SAP
            Invoice Management by OpenText" specifically for digitalising AP invoice workflows. This category
            often goes beyond "extraction" into approval routing, compliance, and SAP-centric AP processing.
          </p>

          <h2 className="sap-sub-title">Invoice-parsing APIs (Mindee, Veryfi, Nanonets, Klippa):</h2>
          <p className="sap-p">
            These vendors are relevant when you want a fast REST integration and are comfortable building
            your own SAP posting layer:
          </p>
          <ul style={ul}>
            <li className="sap-li">
              <strong>Mindee:</strong> markets an invoice OCR API extracting structured fields and line items;
              its SDK documentation for Invoice v4 exposes line items and confidence for extracted elements.
            </li>
            <li className="sap-li">
              <strong>Veryfi:</strong> provides invoice OCR and explicit API endpoints for retrieving document
              line items; pricing is shown as transaction-based in public materials.
            </li>
            <li className="sap-li">
              <strong>Nanonets:</strong> invoice OCR page lists line items, and its pricing/features page
              lists "SAP" among integration/export options (validate the exact plan and connector scope).
            </li>
            <li className="sap-li">
              <strong>Klippa:</strong> publishes an SAP integration page for invoice processing and also
              markets "invoice data extraction accuracy up to 99%" (treat as a marketing claim until validated).
            </li>
          </ul>

          {/* ── SHORTLIST ── */}
          <h1 className={`sap-page-title sap-page-title-mt2`}>
            Recommended shortlist for high-quality SAP invoice ingestion
          </h1>

          <p className="sap-p">
            Because languages and volumes are unspecified, the best shortlist should cover three axes:{" "}
            <strong>enterprise controls</strong>, <strong>multilingual robustness</strong>, and{" "}
            <strong>deployment/security constraints</strong> (cloud vs on-prem). The recommendations below
            assume high accuracy requirements typical for financial postings, and that you will implement{" "}
            <strong>validation + parking workflow</strong> rather than blind auto-posting.
          </p>

          <h2 className="sap-sub-title">SAP Document Information Extraction on SAP BTP:</h2>
          <p className="sap-p">
            <strong>Why shortlist:</strong> best alignment with SAP ecosystem (identity, integration
            patterns, SAP-native operations/monitoring) and straightforward pairing with S/4 APIs such as
            Supplier Invoice – OData.
          </p>
          <p className="sap-p">
            <strong>Trade-offs:</strong> you must validate invoice coverage (document types, languages) and
            confirm operational constraints and pricing under your SAP contract. SAP's data protection note
            also indicates feedback/instant learning features are not intended for special categories of
            personal data under GDPR Article 9—important for governance if invoices can contain sensitive data.
          </p>
          <p className="sap-p">
            <strong>Estimated effort:</strong> typically 8–14 weeks for a production-grade flow (extraction
            + mapping + SAP posting + exceptions), faster if using SAP Build Process Automation templates and
            if document variability is modest.
          </p>

          <h2 className="sap-sub-title">Azure Document Intelligence (Invoice model) with container option:</h2>
          <p className="sap-p">
            <strong>Why shortlist:</strong> strong enterprise service limits (e.g., up to 2000 pages per
            analysis in standard tier) and explicit on-prem/container support for data governance when
            invoices cannot leave your controlled environment.
          </p>
          <p className="sap-p">
            <strong>Trade-offs:</strong> you still need supplier-specific improvement loops (custom models,
            rules); and you must design SAP posting carefully (park/post with audit logging).
            Confidence-based gating is essential.
          </p>
          <p className="sap-p">
            <strong>Estimated effort:</strong> 8–16 weeks (containers and secure network integration can add time).
          </p>

          <h2 className="sap-sub-title">
            Google Document AI Invoice Parser with uptraining + SAP Cloud Integration pattern:
          </h2>
          <p className="sap-p">
            <strong>Why shortlist:</strong> mature invoice parsing plus a well-documented SAP integration
            reference architecture showing threshold-based HITL and SAP Cloud Integration for validations
            and upload, delivered in under three months in the FibroGen case study.
          </p>
          <p className="sap-p">
            <strong>Trade-offs:</strong> processor page limits and region planning must be checked (especially
            for very long invoices); generative-AI extraction in Document AI has separate constraints if used.
          </p>
          <p className="sap-p">
            <strong>Estimated effort:</strong> 6–12 weeks if following a similar reference pattern (longer
            if complex SAP validation/matching rules).
          </p>

          <h2 className="sap-sub-title">ABBYY Vantage / FlexiCapture for SAP-centric enterprises:</h2>
          <p className="sap-p">
            <strong>Why shortlist:</strong> enterprise-grade IDP focus, strong HITL + continuous learning
            concepts, and explicit SAP Intelligent RPA connector plus SAP partnership positioning.
          </p>
          <p className="sap-p">
            <strong>Trade-offs:</strong> licensing/packaging is more enterprise-sales driven; solution design
            can be heavier than hyperscaler APIs; validate multilingual and deployment specifics per
            product/edition.
          </p>
          <p className="sap-p">
            <strong>Estimated effort:</strong> 10–20 weeks depending on workflow depth (capture,
            classification, validation UI, SAP posting, audit).
          </p>

          <h2 className="sap-sub-title">Rossum with SAP certified integrations:</h2>
          <p className="sap-p">
            <strong>Why shortlist:</strong> Rossum states SAP partnership and certified integrations; has a
            customer story with explicit "95% data extraction accuracy" and fast processing lead time, which
            is unusually concrete for marketing materials.
          </p>
          <p className="sap-p">
            <strong>Trade-offs:</strong> SaaS-first posture may or may not fit your data residency/on-prem
            constraints; validate governance, retention, and integration certification scope for ECC vs S/4.
          </p>
          <p className="sap-p">
            <strong>Estimated effort:</strong> 6–12 weeks typical for queue-based invoice automation if SAP
            connectivity path is available.
          </p>

          {/* ── EVALUATION PLAN ── */}
          <h1 className={`sap-page-title sap-page-title-mt3`}>
            Evaluation plan and pilot metrics for a rigorous SAP invoice ingestion proof
          </h1>

          <h2 className="sap-sub-title">Dataset design:</h2>
          <p className="sap-p">
            Because invoice layouts, suppliers, scan quality and language are the primary drivers of accuracy
            variance, the dataset should be stratified. A practical approach:
          </p>

          <h2 className="sap-sub-title">Pilot dataset size:</h2>
          <p className="sap-p">
            Minimum <strong>500–1,000 invoices</strong> to get stable estimates for common
            suppliers/layouts. If multi-language is required, follow a per-language sizing approach; Google's
            invoice labelling guidance recommends{" "}
            <strong>at least 1,000 training documents per language</strong> and{" "}
            <strong>at least 200 test documents per language</strong> when uptraining. Include representation
            for: scanned vs digital PDFs; 1-page vs multi-page; long line-item tables; credit memos;
            PO-based invoices; non-PO invoices; and at least the top ~20 suppliers by volume plus a
            long-tail sample.
          </p>

          <h2 className="sap-sub-title">Ground-truthing strategy:</h2>
          <p className="sap-p">Create ground truth at two levels:</p>
          <ul style={ulSm}>
            <li className="sap-li">
              <strong>Field ground truth:</strong> invoice number, invoice date, supplier name/address,
              tax ID, PO number, net/tax/total, currency, payment terms.
            </li>
            <li className="sap-li">
              <strong>Line-item ground truth:</strong> per row: description, quantity, unit, unit price,
              line amount, product/service code, tax rate if present.
            </li>
          </ul>
          <p className="sap-p">
            To make results defensible, track annotation rules for multi-occurrence: Google guidance
            distinguishes OPTIONAL_ONCE vs OPTIONAL_MULTIPLE and treats line items as multi-occurrence.
          </p>

          <h2 className="sap-sub-title">Metrics to compute:</h2>
          <p className="sap-p">Use a metric suite that reflects SAP posting risk:</p>
          <ul style={ul}>
            <li className="sap-li">
              <strong>Exact match accuracy</strong> for key identifiers (invoice number, PO number) and
              dates (after normalisation).
            </li>
            <li className="sap-li">
              <strong>Numeric tolerance accuracy</strong> for amounts (e.g., absolute tolerance ±0.01 in
              invoice currency) and tax fields; also validate the accounting identity: subtotal + tax +
              shipping − discounts = total.
            </li>
            <li className="sap-li">
              <strong>Field-level precision/recall/F1</strong> for presence/absence fields (e.g., due date
              present vs missing).
            </li>
            <li className="sap-li">
              <strong>Line-item table metrics:</strong>
              <ul style={ulNested}>
                <li className="sap-li"><strong>Row-level match rate</strong> (correct grouping of cells into the same line item).</li>
                <li className="sap-li"><strong>Cell-level accuracy/F1</strong> across the line-item schema.</li>
                <li className="sap-li"><strong>End-to-end reconciliation success</strong> (e.g., correct PO match rate if PO-based processing is in scope).</li>
              </ul>
            </li>
            <li className="sap-li">
              <strong>Operational KPI metrics:</strong>
              <ul style={ulNested}>
                <li className="sap-li"><strong>STP rate (straight-through processing):</strong> percentage of invoices posted/parked without human correction.</li>
                <li className="sap-li"><strong>HITL rate:</strong> percentage routed to manual review.</li>
                <li className="sap-li"><strong>Time to process</strong> (p50/p95), and <strong>cost per invoice</strong> (all-in).</li>
              </ul>
            </li>
          </ul>

          <h2 className="sap-sub-title">Acceptance thresholds for finance-grade SAP posting:</h2>
          <p className="sap-p">Set separate thresholds for "park" vs "post":</p>
          <ul style={ulSm}>
            <li className="sap-li">
              <strong>Auto-post threshold (strict):</strong>
              <ul style={ulNested}>
                <li className="sap-li">99.5%+ accuracy on total amount, tax amount, and supplier identity mapping;</li>
                <li className="sap-li">≥98–99% on invoice number/date;</li>
                <li className="sap-li">≥95% cell-level accuracy on line items for PO-based matching use cases, with deterministic validations for totals.</li>
              </ul>
            </li>
            <li className="sap-li">
              <strong>Auto-park threshold (looser):</strong> allow lower line-item certainty if invoices are
              parked for AP review, but still require high confidence on header identifiers and totals.
            </li>
          </ul>
          <p className="sap-p">
            Use <strong>confidence gating</strong> where available. Microsoft explains confidence as a
            probability and explicitly recommends using confidence to decide whether to accept automatically
            or route to human review.
          </p>

          <h2 className="sap-sub-title">A/B testing structure:</h2>
          <p className="sap-p">Run at least two A/B comparisons:</p>
          <ul style={ul}>
            <li className="sap-li">
              <strong>A/B-1: Engine comparison</strong> using the same dataset and the same ground truth:
              <ul style={ulNested}>
                <li className="sap-li">A = current/baseline approach (manual + OCR/templates or existing tool)</li>
                <li className="sap-li">B = candidate Document AI/IDP tool</li>
              </ul>
            </li>
            <li className="sap-li">
              <strong>A/B-2: With vs without uptraining/customisation</strong> for the same engine (where supported):
              <ul style={ulNested}>
                <li className="sap-li">B1 = out-of-the-box invoice model</li>
                <li className="sap-li">B2 = tuned/uptrained/custom model with supplier exemplars</li>
              </ul>
            </li>
          </ul>
          <p className="sap-p">
            Track not only accuracy, but also <strong>where errors occur</strong> (supplier blocks, totals,
            PO number, table row grouping). This error taxonomy drives the deployment plan (rules vs model
            tuning vs UI validation).
          </p>

          {/* ── REFERENCE ARCHITECTURES ── */}
          <h1 className={`sap-page-title sap-page-title-mt3`}>
            Reference architectures and integration patterns into SAP
          </h1>

          <h2 className="sap-sub-title">Core "document-to-SAP" pipeline pattern:</h2>

          <div className="sap-code-block">
            <pre>{`Invoice intake
(Email / SFTP / Portal / Scan)
        ↓
Pre-processing
(De-skew, split, dedupe, barcode/QR, classify)
        ↓
Extraction layer
(Document AI / IDP / Invoice API)
        ↓
Validation & Normalisation
(Totals/tax checks · Date/currency normalisation
 Vendor/PO matching · Duplicate detection)
        ↓
    ┌───────────────────────────────────────┐
    │ High confidence → Auto-post / Auto-park│
    │ Low confidence / exceptions → HITL    │
    └───────────────────────────────────────┘
                    ↓
        SAP Integration Layer
     (Middleware / API gateway / iPaaS)
                    ↓
         SAP ECC or S/4HANA
                    ↓
       Monitoring & audit
  (Logs, evidence archive, reprocessing queue)`}</pre>
          </div>

          <p className="sap-p">
            Why this pattern is "enterprise-safe": it separates probabilistic extraction from deterministic
            validation and makes posting decisions auditable.
          </p>

          <h2 className="sap-sub-title">SAP posting interface choices:</h2>

          <div className="sap-code-block">
            <pre>{`Structured invoice JSON
(header + line items + confidence)
        ↓
┌─────────────────────────────────────────────────────┐
│  Option 1: OData / REST APIs                        │
│  S/4HANA: Supplier Invoice OData                    │
│  (API_SUPPLIERINVOICE_PROCESS_SRV_0001)             │
├─────────────────────────────────────────────────────┤
│  Option 2: IDoc                                     │
│  INVOIC02 (invoice/billing IDoc)                    │
├─────────────────────────────────────────────────────┤
│  Option 3: BAPI / RFC                               │
│  (e.g., FI/AP posting BAPIs)                        │
│  Common in ECC landscapes                           │
└─────────────────────────────────────────────────────┘`}</pre>
          </div>

          <p className="sap-p">
            SAP's Supplier Invoice OData service explicitly supports creating supplier invoices and related
            posting states. SAP also provides technical information for INVOIC02 (invoice IDoc), commonly
            used in invoice/billing integration scenarios.
          </p>

          <h2 className="sap-sub-title">Example: published Google → SAP integration pattern:</h2>
          <p className="sap-p">
            The FibroGen case study describes an implementation where Document AI output is forwarded to{" "}
            <strong>SAP Cloud Integration</strong>, which enforces business rules and uploads into SAP, with
            a threshold-based human review step. This is a directly reusable architecture concept even if
            you swap Document AI providers.
          </p>

          {/* ── OPEN-ENDED ASSUMPTIONS ── */}
          <h1 className={`sap-page-title sap-page-title-mt3`}>
            Notes on open-ended assumptions and how they affect selection
          </h1>

          <ul style={ul}>
            <li className="sap-li">
              <strong>ECC vs S/4HANA:</strong> S/4 makes OData/API-first integration more natural (e.g.,
              Supplier Invoice – OData). ECC-heavy estates often lean on IDocs/BAPIs/RFC and sometimes RPA
              for legacy UI flows.
            </li>
            <li className="sap-li">
              <strong>Languages:</strong> If languages are diverse, prioritise engines with explicit
              multilingual support and/or multi-model per-language strategies. Google's guidance explicitly
              suggests potentially using more than one processor to support multiple languages and provides
              per-language dataset sizing for uptraining. AWS Textract lists supported OCR languages for
              text detection (limited set in core docs), which can be a gating constraint for non-European
              languages.
            </li>
            <li className="sap-li">
              <strong>Volumes/latency:</strong> If volumes are high, throughput quotas matter. Azure
              documents default TPS limits (e.g., 15 TPS analyse requests) and maximum pages; AWS documents
              TPS/concurrent job quota concepts and very large async document limits.
            </li>
            <li className="sap-li">
              <strong>Data governance / on-prem:</strong> If invoices cannot leave your environment,
              prioritise vendors with explicit on-prem/container deployments (Azure containers are explicitly
              documented; many enterprise IDP vendors also offer private deployments, but validate
              contractually).
            </li>
          </ul>

          {/* ── REFERENCES ── */}
          <h1 className={`sap-page-title sap-page-title-mt3`}>References</h1>

          <div className="sap-refs-box">
            {references.map((link, i) => (
              <p key={i} className="sap-link">{link}</p>
            ))}
          </div>

          {/* ── NAV FOOTER ── */}
          <div className="sap-nav-footer">
            <div className="sap-nav-prev" onClick={() => navigate("/blogs/ai-catalog")}>
              <h2 className="sap-nav-post-title">
                300+ AI, GenAI, LLM & AI Agent Technologies — The Ultimate Catalog
              </h2>
              <p className="sap-nav-label">← Previous post</p>
            </div>

            <div className="sap-nav-next" onClick={() => navigate("/blogs/gstr-reconciliation")}>
              <h2 className="sap-nav-post-title">GSTR Reconciliation</h2>
              <p className="sap-nav-label">Next post →</p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default SAPAutomationPage;
